import * as React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import AccountMenu from "./AccountMenu";
import "../style/Navbar.css";

function NavScroll(props) {

  const { setBackdropOpen, setOpenSettings } = props;

  const moreNavRef = React.useRef();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    moreNavRef.current.classList.add("active");
  };
  const handleClose = () => {
    setAnchorEl(null);
    moreNavRef.current.classList.remove("active");
  };
  const handleMinecraft = () => {
    setAnchorEl(null);
    window.location.href = "https://philoop.net/mc/";
  };
  const handleDiscord = () => {
    setAnchorEl(null);
    window.location.href = "https://philoop.net/discord/";
  };
  const handleContactUs = () => {
    setAnchorEl(null);
    window.location.href = "https://philoop.net/";
  };
  return (
    <Navbar fixed="top" bg="dark" variant="dark" style={{height: 58}} onClick={() => setBackdropOpen(false)}>
      <Container fluid>
      <Tooltip title="Home"><a href="https://philoop.net/"><img src="https://philoop.net/favicon.png" alt="PepegaNet Logo" style={{display: "flex", justifyContent: "center", alignItems: "center", paddingRight: 7}}></img></a></Tooltip>
        <div style={{display: "flex", justifyContent: "center", alignItems: "center", color: "grey", fontSize: 25, paddingRight: 7}}>|</div>
        <Navbar.Brand style={{display: "flex"}} onClick={() => window.location.reload()} href="#">BBCode Editor<div style={{fontSize: 10, marginTop: 3, marginLeft: 3, backgroundColor: "#e8cf40", height: 12, color: "black", textAlign: "center", display: "flex", alignItems: "center", borderRadius: 3, paddingLeft: 2, paddingRight: 2}}>BETA</div></Navbar.Brand>
        <Nav
          className="me-auto my-2 my-lg-0"
          style={{ maxHeight: '100px' }}
        >
          <Tooltip title="My BBCode" className="Nav_Link"><Nav.Link onClick={() => window.location.reload()}>My BBCode</Nav.Link></Tooltip>
          <Tooltip title="Radio" className="Nav_Link"><Nav.Link href="https://philoop.net/radio/">Radio</Nav.Link></Tooltip>
          <Tooltip title="Clips" className="Nav_Link"><Nav.Link href="https://philoop.net/clips/">Clips</Nav.Link></Tooltip>
          <Tooltip title="More" className="Nav_Link"><Nav.Link href="#" id="MoreNav" ref={moreNavRef} onClick={handleClick} size="small" sx={{ ml: 2 }} aria-controls={open ? 'account-menu' : undefined} aria-haspopup="true" aria-expanded={open ? 'true' : undefined}>More <FontAwesomeIcon icon={faCaretDown} /></Nav.Link></Tooltip>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: 'visible',
                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                mt: 1.5,
                '& .MuiAvatar-root': {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                '&:before': {
                  content: '""',
                  display: 'block',
                  position: 'absolute',
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: 'background.paper',
                  transform: 'translateY(-50%) rotate(45deg)',
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
          >
            <MenuItem onClick={handleMinecraft}>
              Minecraft
            </MenuItem>
            <MenuItem onClick={handleDiscord}>
              Discord
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleContactUs}>
              Contact Us
            </MenuItem>
          </Menu>
        </Nav>
        <AccountMenu setOpenSettings={setOpenSettings} />
      </Container>
    </Navbar>
  );
}

export default NavScroll;